import React, { useState, useRef } from 'react';
import './DeliverableSidebar.scss';

const DeliverableSidebar = ({
  deliverables,
  activeTabId,
  onSelectTab,
  onDeleteDeliverable,
  onEditTitleSave,
  onAddDeliverable,
  onMoveDeliverable,
}) => {
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const editRef = useRef(null);
  const addRef = useRef(null);

  const handleEditStart = (d) => {
    setEditingId(d.id);
    setEditValue(d.title);
    setTimeout(() => editRef.current?.focus(), 0);
  };

  const handleEditSave = (d) => {
    setEditingId(null);
    const trimmed = editValue.trim();
    if (!trimmed || trimmed === d.title) return;
    onEditTitleSave(d, trimmed);
  };

  const handleAdd = () => {
    if (!newTitle.trim()) return;
    onAddDeliverable(newTitle.trim());
    setNewTitle('');
    setShowAdd(false);
  };

  return (
    <div className="dl-sidebar" data-tour="dl-sidebar">
      <div className="dl-sidebar-list">
        {deliverables.map((d, index) => {
          const items = d.deliverable_items || [];
          const doneCount = items.filter((i) => i.is_completed).length;
          const totalCount = items.length;
          const isActive = activeTabId === d.id;
          const isFirst = index === 0;
          const isLast = index === deliverables.length - 1;

          return (
            <div
              key={d.id}
              className={`dl-sidebar-item ${isActive ? 'active' : ''} ${d.qa_status === 'success' ? 'qa-success' : ''} ${d.qa_status === 'fail' ? 'qa-fail' : ''}`}
              onClick={() => onSelectTab(d.id)}
              onDoubleClick={() => handleEditStart(d)}
              title="雙擊編輯標題"
            >
              {editingId === d.id ? (
                <input
                  ref={editRef}
                  className="dl-sidebar-edit-input"
                  value={editValue}
                  onChange={(e) => setEditValue(e.target.value)}
                  onBlur={() => handleEditSave(d)}
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) => {
                    if (e.nativeEvent.isComposing) return;
                    if (e.key === 'Enter') handleEditSave(d);
                    if (e.key === 'Escape') setEditingId(null);
                  }}
                />
              ) : (
                <>
                  <span className="dl-sidebar-title">{d.title}</span>
                  <div className="dl-sidebar-meta">
                    {d.qa_status === 'success' && <span className="dl-sidebar-qa pass">✓</span>}
                    {d.qa_status === 'fail' && <span className="dl-sidebar-qa fail">✗</span>}
                    {totalCount > 0 && (
                      <span className="dl-sidebar-count">{doneCount}/{totalCount}</span>
                    )}
                  </div>
                  <div className="dl-sidebar-actions">
                    <button
                      className="dl-sidebar-move"
                      disabled={isFirst}
                      onClick={(e) => { e.stopPropagation(); onMoveDeliverable?.(d.id, 'up'); }}
                      title="上移"
                    >
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M5 8V2M2.5 4.5L5 2l2.5 2.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <button
                      className="dl-sidebar-move"
                      disabled={isLast}
                      onClick={(e) => { e.stopPropagation(); onMoveDeliverable?.(d.id, 'down'); }}
                      title="下移"
                    >
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M5 2v6M2.5 5.5L5 8l2.5-2.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <button
                      className="dl-sidebar-delete"
                      onClick={(e) => { e.stopPropagation(); onDeleteDeliverable(d.id); }}
                      title="刪除交付項目"
                    >
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M1.5 1.5l7 7M8.5 1.5l-7 7" strokeLinecap="round" />
                      </svg>
                    </button>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>

      {/* Add deliverable */}
      <div className="dl-sidebar-add" data-tour="dl-sidebar-add">
        {showAdd ? (
          <div className="dl-sidebar-add-input">
            <input
              ref={addRef}
              placeholder="交付項目名稱..."
              value={newTitle}
              onChange={(e) => setNewTitle(e.target.value)}
              onKeyDown={(e) => {
                if (e.nativeEvent.isComposing) return;
                if (e.key === 'Enter') handleAdd();
                if (e.key === 'Escape') { setShowAdd(false); setNewTitle(''); }
              }}
              onBlur={() => {
                if (!newTitle.trim()) { setShowAdd(false); setNewTitle(''); }
              }}
            />
          </div>
        ) : (
          <button
            className="dl-sidebar-add-btn"
            onClick={() => {
              setShowAdd(true);
              setNewTitle('');
              setTimeout(() => addRef.current?.focus(), 0);
            }}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 1v10M1 6h10" strokeLinecap="round" />
            </svg>
            新增交付項目
          </button>
        )}
      </div>
    </div>
  );
};

export default DeliverableSidebar;
